export function getPrice(price) {
    if (!price) {
        return { price: 0.00, number: "0", decimal: "00", symbol: "€" };
    }
    let finalPrice = price;
    finalPrice = finalPrice.toFixed(2);
    const strPrice = finalPrice.toString().split(".");
    return { price: finalPrice, number: strPrice[0], decimal: strPrice[1], symbol: "€" };
}